<template>
    <!-- Navbar dropdowns -->
    <b-nav-item-dropdown v-show="isOK == true" text="Admin" left>
        <b-dropdown-item  exact to="/home/usuarios">Lista de usuarios</b-dropdown-item>
        <b-dropdown-item  exact to="/home/crear_usuarios">Crear usuarios</b-dropdown-item>
        <b-dropdown-item  exact to="/home/usuarios_inactivos">Usuarios inactivos</b-dropdown-item>
        <b-dropdown-item exact to="/home/roles">Crear roles</b-dropdown-item>
        <b-dropdown-item exact to="/home/etiquetas">Crear etiquetas</b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
       
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']),   
        },
        methods:{
            ...mapActions({
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isAdmin(this.permiso) 
                })
            },
        }//end methods        
    }
</script>

<style lang="scss" scoped>

</style>